<template>
<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <mask id="pupil" maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse">
        <ellipse cx="50" cy="50" rx="50" ry="30" fill="white"/>
        <ellipse cx="50" cy="50" rx="16" ry="16" fill="black"/>
    </mask>
    <rect :height="height" width="100" x="0" :y="y" mask="url(#pupil)" />
</svg>
</template>

<script>
import TweenLite from "gsap";

const animationLenght = 0.2;
const animationDelay = 0.15;

const startHeight = 100;
const targetHeight = 0;
const startY = 0;
const targetY = 50;

export default {
  name: "icon-view",
  props: {
    selected: Boolean
  },
  data() {
    return {
      height: startHeight,
      y: startY
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler: function() {
          if(this.selected){
              this.closeEye();
          }
      }
    }
  },
  methods: {
    closeEye() {
      const open = TweenLite.to(this.$data, animationLenght, {
        delay: animationDelay,
        height: targetHeight,
        y: targetY,
        onComplete: this.openEye
      });
    },
    openEye() {
      const open = TweenLite.to(this.$data, animationLenght, {
        height: startHeight,
        y: startY,
      });
    }
  }
};
</script>